<template>
  <section>
    <div class="text-center">
      <img src="@/assets/images/how_to.png" class="img-fluid w-75 pb-5" alt="logo">
    </div>
  </section>
</template>

<script setup>
</script>

<style>
</style>
